import { Theme, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
// sidebar 698px + footer 100px;
const SIDEBAR_CONTENT_HEIGHT = 860;

const useWindowSize = () => {
  const theme: Theme = useTheme();
  const breakpointMD: number = theme.breakpoints.values.md;
  const [position, setPosition] = useState<string>("fixed");
  const [marginLeft, setMarginLeft] = useState<string>("340px");

  useEffect(() => {
    // Handler to call on window resize
    const handleResize: () => void = () => {
      const { innerHeight, innerWidth } = window;
      const isWindowHigherThenSidebar: boolean =
        innerHeight >= SIDEBAR_CONTENT_HEIGHT;
      const isDesktop: boolean = innerWidth >= breakpointMD;
      setPosition(isWindowHigherThenSidebar ? "fixed" : "relative");
      setMarginLeft(isWindowHigherThenSidebar && isDesktop ? "340px" : "0px");
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { position, marginLeft };
};

export { useWindowSize };
